import { StanModal } from '@/components';
import { AffiliateReseller } from '../../types/affiliateAnalytics.types';
import { useAffiliateActions } from '../../queries/useAffiliateActions';
import { stanNotify } from '@/lib';

interface RevokeAccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    reseller: AffiliateReseller | null;
    pageId: string;
}

export function RevokeAccessModal({ isOpen, onClose, reseller, pageId }: RevokeAccessModalProps) {
    const { revokeAccess } = useAffiliateActions(pageId);
    const handleRevoke = () => {
        if (!reseller) return;

        revokeAccess.mutate(reseller.id, {
            onSuccess: () => {
                stanNotify({
                    type: 'success',
                    title: 'Success',
                    text: 'Affiliate access has been revoked',
                });
                onClose();
            },
            onError: (error: any) => {
                stanNotify({
                    type: 'error',
                    title: 'Unable to Revoke Access',
                    text: error.response?.data?.message || 'Failed to revoke access',
                });
            },
        });
    };

    return (
        <StanModal
            id='revoke-access-modal'
            isOpen={isOpen}
            title='Revoke Resell Rights'
            primaryActionLabel='Yes, Revoke Access'
            secondaryActionLabel='Cancel'
            onPrimaryAction={handleRevoke}
            onSecondaryAction={onClose}
            onClose={onClose}
            primaryActionLoading={revokeAccess.isPending}
            primaryActionDisabled={revokeAccess.isPending}
            size='sm'
        >
            <div className='text-gray text-center font-semibold'>
                Are you sure you want to revoke resell rights for this affiliate?
            </div>
        </StanModal>
    );
}
